import { createI18n } from "vue-i18n";
import english from "./locales/english.json";
// Define your translations
const messages = {
  english: {
    ...english,
  },
};

// Create the i18n instance with global settings
const i18n = createI18n({
  legacy: false,
  locale: "english", // Set the default locale
  fallbackLocale: "english", // Fallback language if the key is missing
  messages, // Set locale messages
});

export default i18n;
